import useOnclickOutside from 'react-cool-onclickoutside';
import TabGroup from '../../../../pages/dashboard/TabGroup';
import InformationTab from './InformationTab';
import IconButton from '../../../atoms/button/IconButton';
import ResearchConsentTab from './ResearchConsentTab';
import SquareCard from '../../../organisms/SquareCard';

export interface AgreementModalProps {
  initialActiveTabIndex?: number;
  onClose?: () => void;
}

export default function AgreementModal({ initialActiveTabIndex = 0, onClose }: AgreementModalProps) {
  const ref = useOnclickOutside(
    () => {
      onClose?.();
    },
    { eventTypes: ['mouseup'] }
  );

  return (
    <SquareCard
      className="relative max-w-screen-lg animate-slidein overflow-y-scroll p-16 mx-6 sm:mx-16 my-12"
      innerRef={ref}
    >
      <IconButton className="absolute right-8 top-8" visualType="no-bg" onClick={onClose} icon="close" />
      <TabGroup
        tabs={[
          { label: 'User agreement', component: <InformationTab onClose={onClose} /> },
          { label: 'Research consent', component: <ResearchConsentTab onClose={onClose} /> },
        ]}
        initialActiveTabIndex={initialActiveTabIndex}
      />
    </SquareCard>
  );
}
